(() => {
  const DELAY = 250;
  const parent = document.currentScript.parentElement;
  const input = parent.querySelector('[data-search-input]');
  const output = parent.querySelector('[data-search-output]');

  function debounce(fn, time) {
    let timeout;
    return function () {
      // eslint-disable-next-line prefer-rest-params
      if (fn) {
        const functionCall = () => fn.apply(this, arguments);
        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
      }
    };
  }

  const close = () => {
    input.value = '';
    output.hidden = true;
  };

  const render = async (results) => {
    const fetches = results.products.map((product) => fetch(`/products/${product.handle}?view=search-item`));
    const items = await Promise.all(fetches);
    const strings = await Promise.all(items.map((item) => item.text()));
    const html = strings.map((str) => str).join('');
    output.hidden = false;
    output.innerHTML = html;
  };

  const search = async (q) => {
    output.innerHTML = '<div class="load-spinner"></div>';
    output.hidden = false;
    const url = new URL(window.location.origin);
    url.pathname = `${window.theme.routes.predictive_search_url}.json`;
    url.searchParams.set('q', q);
    const response = await fetch(url);
    if (!response.ok) {
      if (response.error) {
        console.error(response.error);
      }
      console.error(await response.text());
      return;
    }
    const data = await response.json();
    render(data.resources.results);
  };

  const onKeyUp = async (event) => {
    const q = event.target.value;
    if (q.length === 0) { close(); return; }
    search(q);
  };

  input.addEventListener('keyup', debounce(onKeyUp, DELAY));
})();